@if (context()) {
  <igo-context-form
    [btnSubmitText]="'igo.context.contextManager.save' | translate"
    [context]="context()"
    (submitForm)="onEdit($event)"
  />
}
